import { render } from "./ImageGalleryField.vue?vue&type=template&id=2b9c3b30"
import script from "./ImageGalleryField.vue?vue&type=script&lang=js"
export * from "./ImageGalleryField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ImageGalleryField.vue"]])

export default __exports__